enum types {
  AddRequest = 'contacts/ADD_REQUEST',
  AddContacts = 'contacts/ADD_CONTACTS',
  AddError = 'contacts/ADD_ERROR',
}

export const ContactsTypes = {
  ...types,
};
